export const THEME_FILES = {'dark': 'theme-dark.chunk.css', 'light': 'theme-light.chunk.css'};

export const SCREEN_SIZES = {
    mobile: [0, 850],
    tablet: [850, 1024],
    desktop: [1024, 1000000]
}